import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María G.', 'Carlos R.', 'Ana P.', 'José M.', 'Laura S.', 'Diego F.', 'Sofía L.', 'Miguel A.', 'Valentina C.', 'Juan D.', 'Martín B.', 'Camila T.', 'Fernando L.', 'Lucía M.', 'Pablo S.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'San Miguel de Tucumán', 'Santa Fe', 'Neuquén'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name,
        city
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    const initialTimeout = setTimeout(showNotification, 5000);
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 30000 + 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-73">
      {visible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} className="fixed bottom-4 right-4 z-50 max-w-sm bg-slate-900 border border-green-500/30 rounded-lg shadow-2xl p-4 flex items-center gap-3 backdrop-blur-sm" data-id="element-74">
          <div className="bg-green-500/20 p-2 rounded-full" data-id="element-75">
            <CheckCircle2 className="w-6 h-6 text-green-400" data-id="element-76" />
          </div>
          <div data-id="element-77">
            <p className="text-sm font-bold text-white" data-id="element-78">
              {data.name} de {data.city}
            </p>
            <p className="text-xs text-slate-300" data-id="element-79">
              acaba de comprar este libro digital
            </p>
            <p className="text-[10px] text-green-400 mt-1 font-semibold" data-id="element-80">
              Verificado hace instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}